// src/services/bi/KPICard.js
import React from 'react';

const KPICard = ({ 
  label, 
  icon, 
  value, 
  interpretation, 
  color = 'score',
  trend = null,
  lastWeekValue = null,  // ← NOUVEAU : valeur de la semaine dernière
  subtitle = null,       // ← NOUVEAU : texte supplémentaire
  className = ''
}) => {
  // Déterminer la flèche et la couleur selon la tendance
  const getTrendDisplay = (trend) => {
    if (!trend && trend !== 0) return null;
    
    const trendNum = parseInt(trend);
    if (trendNum > 0) {
      return { symbol: '↑', text: `+${trendNum}`, color: 'up' };
    } else if (trendNum < 0) {
      return { symbol: '↓', text: `${trendNum}`, color: 'down' };
    } else {
      return { symbol: '→', text: '0', color: 'stable' };
    }
  };
  
  const trendDisplay = getTrendDisplay(trend);
  
  // Générer le texte de comparaison si lastWeekValue existe
  const getComparisonText = () => {
    if (subtitle) return subtitle;
    if (lastWeekValue !== null && lastWeekValue !== undefined) {
      return `(vs ${lastWeekValue}% semaine dernière)`;
    }
    return null;
  };
  
  const comparisonText = getComparisonText();

  return (
    <div className={`kpi-card kpi-card--${color} ${className}`}>
      <div className="kpi-card__header">
        {/* Icône colorée */}
        <div className="kpi-card__icon">{icon}</div>

        {/* Texte groupé : label + valeur + trend */}
        <div className="kpi-card__header-text">
          <div className="kpi-card__label">{label}</div>
          <div className="kpi-card__value">{value}</div>
          {comparisonText && (
            <div className="kpi-card__comparison">{comparisonText}</div>
          )}
          {trendDisplay && (
            <div className={`kpi-card__trend kpi-card__trend--${trendDisplay.color}`}>
              {trendDisplay.symbol} {trendDisplay.text} vs semaine dernière
            </div>
          )}
        </div>
      </div>

      {/* Interprétation IA */}
      <div className="kpi-card__footer">
        <div className="kpi-card__interpretation">{interpretation}</div>
      </div>
    </div>
  );
};

export default KPICard;